<template>
  <div>
    <base-input
      v-if="forceValue"
      type="text"
      :value="'Company: ' + forceValue"
      disabled="true"
      readonly="true"
    />
    <div v-if="!forceValue">
      <Spinner v-if="loading" />
      <base-input
        v-if="list.length == 1"
        type="text"
        :value="'Department: ' + list[0].name"
        disabled="true"
        readonly="true"
      />
      <select
        class="form-control"
        v-model="selected"
        v-if="list.length !== 1"
        :disabled="disabled || list.length === 0"
      >
        <option :value="-1" selected>Select Company...</option>
        <option v-for="item in list" :key="item.id" :value="item.id">
          {{ item.name }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: {
    forceValue: {
      type: String,
      default: "",
    },
    modelValue: {
      type: Number,
      default: -1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      selected: this.modelValue,
      loading: true,
    };
  },
  watch: {
    selected() {
      this.$emit("update:modelValue", this.selected);
    },
  },
  created() {
    this.clear();
    this.loadData();
  },
  methods: {
    clear() {
      this.list = [];
      this.selected = this.modelValue;
      this.loading = true;
    },
    loadData() {
      const self = this;
      axios.get("/api/companies").then((res) => {
        this.loading = false;
        self.list = res.data.companies;
        if (self.list.length === 1) {
          self.selected = self.list[0].id;
        }
      });
    },
  },
};
</script>
